module.exports = __webpack_public_path__ + "static/media/8Q.7fb4c4bc.png";